export default __webpack_public_path__ + "static/media/robocon2.a6607a17.jpg";